const replaceQuotes = string => {
  return string.replace(/&quot;/g, '"').replace(/&#39;/g, '\'')
}

export default replaceQuotes



// WEBPACK FOOTER //
// ./src/videos/replaceQuotes.js